import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'

import store from './components/alerts/alert-store'

import AlertGroup from './components/alerts/AlertGroup'
import AlertPill from './components/alerts/AlertPill'
import AlertTrigger from './components/alerts/AlertTrigger'

const header = new Vue({
    store,
    el: '#primaryHeader',

    components: {
        AlertGroup,
        AlertPill,
        AlertTrigger,
    },

    data: () => ({
        timer: 10000,
        timeout: null,
    }),

    computed: {
        ...mapState([
            'alerts',
            'alertPanelOpen',
            'focus',
            'initial',
            'initialModeComplete',
            'warningActive',
        ]),
    },

    watch: {
        initial: {
            deep: true,
            handler () {
                if (
                    this.initial.hasScrolled ||
                    this.initial.hasOpenedPill ||
                    this.initial.hasClickedScreen ||
                    this.initial.hasClickedEscape ||
                    this.initial.hasClickedTrigger ||
                    this.initial.hasRunOutTimer
                ) {
                    this.clearFirstLoad()
                }
            },
        },
    },

    beforeMount () {
        let ac = localStorage.getItem('alertsClosedTimestamp');
        if (ac) {
            const then = new Date(parseInt(ac))
            const now = new Date()

            const msBetween = Math.abs(then.getTime() - now.getTime())
            const hoursBetween = msBetween / (60*60*1000) //convert ms to hours

            if (hoursBetween < 168 ) { //hours in a week
                this.removeWarning()
                this.updateInitial({ initialModeComplete: true })
                this.clearFirstLoad()
            } else {
                localStorage.removeItem('alertsClosedTimestamp')
            }
        }
    },

    mounted () {
        this.setAlerts(JSON.parse(this.$el.dataset.alerts))

        if (this.alerts.length && !this.initialModeComplete) {
            window.addEventListener('scroll', this.onScroll, { once: true })
            window.addEventListener('keydown', this.onEscape)

            this.$nextTick(() => {
                setTimeout(() => {
                    this.firstLoad()
                }, 1000)
            })
        }
    },

    methods: {
        ...mapMutations({
            setAlerts: 'SET_ALERTS',
            toggleAlerts: 'TOGGLE_ALERT_PANEL',
            openAlerts: 'SET_ALERT_PANEL_OPEN',
            closeAlerts: 'SET_ALERT_PANEL_CLOSED',
            updateInitial: 'UPDATE_INITIAL',
            completeInitial: 'SET_INITIAL_MODE_COMPLETE',
            removeWarning: 'REMOVE_WARNING',
        }),

        onEscape (e) {
            if (e.key === 'Escape' && this.alertPanelOpen) {
                this.toggleAlerts()

                if (!this.initialModeComplete) {
                    this.removeWarning()
                    this.updateInitial({ hasClickedEscape: true })
                }

                if (!localStorage.getItem('alertsClosedTimestamp')) {
                    localStorage.setItem('alertsClosedTimestamp', new Date().getTime())
                }
            }
        },

        onScroll () {
            this.closeAlerts()
            this.updateInitial({ hasScrolled: true })
        },

        firstLoad () {
            this.openAlerts(false)
            this.timeout = setTimeout(() => {
                if (!this.initialModeComplete) {
                    this.closeAlerts()
                    this.updateInitial({ hasRunOutTimer: true })
                }
            }, this.timer)
        },

        clearFirstLoad () {
            clearTimeout(this.timeout)
            window.removeEventListener('scroll', this.toggleAlerts)
            this.completeInitial()
        },
    },

})

